
// Vue
import { Options, Vue } from 'vue-class-component';

// Interfaces
import { AuthService } from '@/services/AuthService';
import { Subscription } from 'rxjs';


@Options({})
export default class Login extends Vue {
  email = '';
  password = '';

  isLoading = false;
  subsciption!: Subscription;

  $authService!: AuthService;

  mounted () {
    this.subsciption = this.$authService.loadingCounter.subscribe(val => {
      this.isLoading = val > 0;
    })
  }

  unmounted () {
    this.subsciption.unsubscribe();
  }

  handleSubmit (e: Event) {
    e.preventDefault();

    return this.$authService.login(this.email, this.password)
      .then(result => {
        this.$emit('login', result);
        return result;
      })
  }
}
